import { render, staticRenderFns } from "./resume-moving-regions.vue?vue&type=template&id=a88e96ae&"
import script from "./resume-moving-regions.vue?vue&type=script&lang=js&"
export * from "./resume-moving-regions.vue?vue&type=script&lang=js&"
import style0 from "./resume-moving-regions.vue?vue&type=style&index=0&id=a88e96ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports